import { Card, CardContent } from "./card";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface StatCardProps {
    title: string;
    value: string | number;
    description?: string;
    icon?: ReactNode;
    trend?: "up" | "down" | "neutral";
    className?: string;
}

export function StatCard({ title, value, description, icon, className }: StatCardProps) {
    return (
        <Card className={cn("hover:shadow-[var(--shadow-card-hover)]", className)}>
            <CardContent className="p-5">
                <div className="flex items-center justify-between">
                    <p className="text-xs font-semibold uppercase tracking-wide text-foreground/80">{title}</p>
                    {icon && <div className="text-foreground/80">{icon}</div>}
                </div>
                <div className="mt-3">
                    <p className="text-3xl font-bold tracking-tight tabular-nums">{value}</p>
                    {description && <p className="text-xs text-foreground/80 mt-1.5">{description}</p>}
                </div>
            </CardContent>
        </Card>
    );
}
